import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Field, FieldProps, Form } from "react-final-form";
import { format } from "date-fns/format";
import { z } from "zod";
//TODO: UNDERSTAND HOW TO PARSE IT SO I CAN ONLY IMPORT FROM /UI/FORM
import { InputField, MultiSelectOption, SelectOption, getDefaultValue, mapSelectOptionsIdValue, mapSelectOptionsNormalizedValue } from "ui";
import { useSlideInContext } from "../SlideInProvider";
import LoadingButton from "@mui/lab/LoadingButton";

const formValidator = <T extends z.ZodType<any, any>>(schema: T) => (values: any) => {
    try {
        schema.parse(values);
    } catch (err) {
        return (err as z.ZodError).formErrors.fieldErrors;
    }
};


export type AddUserPayload = {
    firstName: string,
    middleName?: string,
    lastName: string,
    roleType: string,
    jobTitle?: string,
    email: string,
    startDate: string
}
// const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
export type AddUserProps = {
    roles: any[],
    locations: any[],
    staffFormFields: any[],
    validatorSchema: any
    onSubmit: (data: AddUserPayload) => Promise<void>
}
const AddUser = ({ roles, locations, staffFormFields, validatorSchema, onSubmit }: AddUserProps) => {
    const [fields, setFields] = useState<FieldProps<string, any>>();
    const [roleOptions, setRoleOptions] = useState<SelectOption[]>([]);
    const [locationOptions, setLocationOptions] = useState<MultiSelectOption[]>([]);
    const { toggleDrawer } = useSlideInContext()

    useEffect(() => {
        var options = mapSelectOptionsNormalizedValue(roles ?? [])
        setRoleOptions(options);
        var _locations = mapSelectOptionsIdValue(locations ?? [])
        setLocationOptions(_locations)
        setFields(() => staffFormFields.map((field) => {
            // if (field.name !== "roleType") return field;
            if (field.name == "roleType") {
                return {
                    ...field,
                    options
                };
            }
            else if (field.name == "location") {
                return {
                    ...field,
                    options: _locations
                }
            } else {
                return field;
            }
        }));
    }, [roles, locations])

    const handleSubmit = async (values: AddUserPayload) => {
        await onSubmit(values)
        toggleDrawer()
    }
    return (
        <div style={{ color: "#fff", paddingTop: "16px" }}>
            <Form
                key={`${roleOptions.length}-${locationOptions.length}`}
                initialValues={{
                    roleType: getDefaultValue(roleOptions),
                    locations: locationOptions[0]?.value,
                    // location: getDefaultValue(locationOptions),
                    startDate: format(new Date(), 'yyyy-MM-dd')
                }}
                onSubmit={handleSubmit}
                validate={formValidator(validatorSchema)}
                render={({ handleSubmit, form, submitting }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid style={{ marginTop: 0 }} container spacing={4} rowSpacing={4}>
                            {fields && fields.map((field: FieldProps<string, any>, i: number) => (
                                <Grid
                                    key={`add-user-field${i + 20}`}
                                    size={field.grid.xs}
                                >
                                    <Field
                                        autoComplete="off"
                                        {...field} />
                                </Grid>
                            ))}
                            <Grid size={6}>
                                <Field
                                    name="startDate"
                                    label="Start Date"
                                    type="date"
                                    component={InputField}
                                    InputLabelProps={{ shrink: true }}
                                    required
                                    disabled
                                    fullWidth
                                />
                            </Grid>
                            <Grid
                                size={12}
                                sx={{ display: "flex", justifyContent: "flex-start" }}
                            >
                                <LoadingButton
                                    loading={submitting}
                                    disableElevation
                                    variant="contained"
                                    size="large"
                                    type="submit"
                                    onClick={() => form.submit()}
                                    sx={{
                                        backgroundColor: "primary.main",
                                        "&:hover": {
                                            backgroundColor: "primary.light",
                                        },
                                    }}
                                >
                                    Save
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </form>
                )}
            />
        </div>
    );
};

export default AddUser;
